import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsArray, UtilsJsonConverterDate, UtilsMisc, UtilsString } from '@pit/core';
import { IDtoShipment } from '../interfaces/dto.shipment.interface';
import { IDtoShipmentProcess, ShipmentDeliveryType, ShipmentProcessState } from '../interfaces/dto.shipment.process.interface';
import { DtoShipmentProcess } from './dto.shipment.process';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';
import { DtoAddressee } from './dto.addressee';
import { IDtoAddressee } from '../interfaces/dto.addressee.interface';
import { IDtoCustomer } from '../interfaces/dto.customer.interface';
import { DtoCustomer } from './dto.customer';
import { IDtoDevice } from '../interfaces/dto.device.interface';
import { DtoDevice } from './dto.device';

// @dynamic
@JsonObject('DtoShipment')
export class DtoShipment extends ModelEntity implements IDtoShipment {

    constructor(initValues: Partial<IDtoShipment> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('depotNumber', String, true)
    public depotNumber?: string = null;

    @JsonProperty('deviceId', String, true)
    public deviceId?: string = null;

    @JsonProperty('externalShipmentId', String, true)
    public externalShipmentId?: string = null;

    @JsonProperty('isMarkedAsTrackable', Boolean, true)
    public isMarkedAsTrackable?: boolean = false;

    @JsonProperty('shipmentDate', UtilsJsonConverterDate, true)
    public shipmentDate?: Date = null;

    @JsonProperty('shipmentNumbers', [String], true)
    public shipmentNumbers?: string[] = [];

    @JsonProperty('productTypeCode', String, true)
    public productTypeCode?: string = null;

    @JsonProperty('productTypeDescription', String, true)
    public productTypeDescription?: string = null;

    @JsonProperty('addressee', DtoAddressee, true)
    public addressee?: IDtoAddressee = null;

    @JsonProperty('customer', DtoCustomer, true)
    public customer?: IDtoCustomer = null;

    @JsonProperty('device', DtoDevice, true)
    public device?: IDtoDevice = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    @JsonProperty('processes', [DtoShipmentProcess], true)
    public processes?: IDtoShipmentProcess[] = [];

    public get fullAddress(): string {
        return this.addressee?.fullAddress;
    }

    public get isFinished(): boolean {
        return (this.currentProcess.isFinished === true);
    }

    public get isOpen(): boolean {
        return (this.isFinished === false);
    }

    public get isSyncedToServer(): boolean {
        let result: boolean = false;
        if ((UtilsMisc.isNullOrUndefined(this.processes) === false) && (this.processes.length > 0)) {
            result = true;
            this.processes.forEach(process => {
                result = result && (process.isSyncedToServer === true);
            });
        }

        return result;
    }

    public get currentProcess(): IDtoShipmentProcess {
        return (((UtilsMisc.isNullOrUndefined(this.processes) === false) && (this.processes.length > 0)) ? this.processes[this.processes.length - 1] : null);
    }

    public get processStateDescription(): string {
        return this.currentProcess?.processStateDescription;
    }

    public userDescription: string = null;

    public userName: string = null;

    public getHasShipmentNumber(shipmentNumber: string): boolean {
        return ((UtilsMisc.isNullOrUndefined(this.shipmentNumbers) === false) && (this.shipmentNumbers.length > 0) && (this.shipmentNumbers.includes(shipmentNumber)));
    }

}
